import axios from 'axios'

export default {
  getCourses: (params) => {
    return new Promise((resolve) => {
      axios.get('modelCourse', { params: params })
        .then(payload => {
          resolve(payload.data.courses)
        })
    })
  },
  getCourseDetail: (params) => {
    return new Promise((resolve) => {
      axios.get('modelCourse/detail', { params: params })
        .then(payload => {
          resolve(payload.data)
        })
    })
  }
}
